//  ----------      START   IMPORT  BLOCK       ----------
import { useLocation } from 'react-router-dom';
import BaseLayout from '../BaseLayout/BaseLayout';
//  Widgets
import CalendarWidget from '../../../../MedicSearchForm/CalendarWidget';
import MapWidget from '../../../../MedicSearchForm/MapWidget';
import ResultsPage from '../../../../MedicSearchForm/SearchResults';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  ----------      END   IMPORT  BLOCK       ----------

function useQueryParams() {
  return new URLSearchParams(useLocation().search);
}

function SearchPage({  }) {
  //  Consume context
  const { lan } = useLanguage();

  const queryParams = useQueryParams();
  const searchTerm = queryParams.get('query') || '';
  const city = queryParams.get('city') || '';

  return (
    <BaseLayout lan={lan}>
      <ResultsPage
        CalendarWidget={CalendarWidget}
        MapWidget={MapWidget}
      />
    </BaseLayout>
  );
}

export default SearchPage;
